export const GET_NOTIFICATIONS_BY_USER = 'GET_NOTIFICATIONS_BY_USER';
export const GET_NOTIFICATIONS_BY_USER_SUCCESS = 'GET_NOTIFICATIONS_BY_USER_SUCCESS';
export const GET_NOTIFICATIONS_BY_USER_FAILED = 'GET_NOTIFICATIONS_BY_USER_FAILED';
export const MARK_NOTIFICATION_AS_READ = 'MARK_NOTIFICATION_AS_READ';
export const MARK_NOTIFICATION_AS_READ_SUCCESS = 'MARK_NOTIFICATION_AS_READ_SUCCESS';
export const MARK_NOTIFICATION_AS_READ_FAILED = 'MARK_NOTIFICATION_AS_READ_FAILED';

export const OPEN_NOTIFICATION_MODAL = 'OPEN_NOTIFICATION_MODAL';
export const CLOSE_NOTIFICATION_MODAL = 'CLOSE_NOTIFICATION_MODAL';

export const CHECK_NEW_NOTIFICATIONS = 'CHECK_NEW_NOTIFICATIONS';
